/**
 * The file enables `@/store/index.js` to import all vuex modules
 * in a one-shot manner. There should not be any reason to edit this file.
 */

export function loadModules() {
  const context = require.context('.', false, /([a-z_]+)\.js$/i);

  const modules = context
    .keys()
    .map(key => ({ key, name: key.match(/([a-z_]+)\.js$/i)[1] }))
    .reduce((modules, { key }) => {
      // If key isn't ./index.js, append to modules array
      if (key !== './index.js')
        return {
          ...modules,
          [key.replace(/(\.\/|\.js)/g, '')]: context(key).default
        };
      // else skip it
      else return { ...modules };
    }, {});

  return { context, modules };
}

const { modules } = loadModules();

export default modules;
